import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Auth, UserRoles } from '../services/auth';

export const adminGuard: CanActivateFn = (route, state): boolean | UrlTree => {
  const authService = inject(Auth);
  const router = inject(Router);

  if (authService.hasRole(UserRoles.ADMIN)) {
    return true;
  } else {
    return router.createUrlTree(['/dashboard']);
  }
};
